import { Badge } from "@stocks/ui";
import type { ItemCategory } from "@stocks/shared";

import { getCategoryLabel } from "../lib/category";

export const ItemCategoryBadge = ({
  category,
}: {
  category: ItemCategory | null;
}) => <Badge variant='secondary'>{getCategoryLabel(category)}</Badge>;
